import { render, staticRenderFns } from "./CovidBanner.vue?vue&type=template&id=0ad04ee3&"
import script from "./CovidBanner.vue?vue&type=script&lang=js&"
export * from "./CovidBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports